import React from 'react'
import {graphql} from 'gatsby'

import Layout from '../../components/Layout'
import IntroSection from './components/IntroSection'
import CoursesListSection from './components/CoursesListSection'

const CoursesListPage = ({data: dataObj}) => {
	const data = dataObj.coursesList.childPagesJson.childPagesJsonWithRelativePaths
	return <Layout seo={{routeUrl: data.url, ...data.seo}}>
		<IntroSection
			data={{url: data.url, title: data.title, text: data.text, scrollButtonLabel: data.scrollButtonLabel}}/>
		<CoursesListSection/>
	</Layout>
}


export default CoursesListPage

export const query = graphql`
{
	coursesList: file(relativePath: {eq: "pages/coursesListPage.json"}) {
    childPagesJson {
      childPagesJsonWithRelativePaths {      	
      	title
      	text
      	url
      	scrollButtonLabel
      	seo {
        	title
          description
          author
          metaImage {
            publicURL
          }
        }
      }
    }
  }
}
`
